export default {
	categories(state) {
		return state.categories
	},
}
